var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronRight, Database, Folder, Loader2 } from 'lucide-react';
import { useQuery } from '@/hoc/hooks/useQuery';
import { useSearchParams } from 'react-router-dom';
import { useUpdateContext } from '@/contextProvider/context.provider';
var DataBaseFolder = function (_a) {
    var _b;
    var _c, _d;
    var dbData = _a.dbData, setCollection = _a.setCollection, setDatabaseInfo = _a.setDatabaseInfo, selectedCollections = _a.selectedCollections, setSelectedCollections = _a.setSelectedCollections, onCollectionSelection = _a.onCollectionSelection, setAllMetaData = _a.setAllMetaData, collectionFieldsData = _a.collectionFieldsData, onCollectionCheckboxChange = _a.onCollectionCheckboxChange;
    var _e = useState([]), expandedDBs = _e[0], setExpandedDBs = _e[1];
    var _f = useState((_b = {},
        _b[((_c = dbData === null || dbData === void 0 ? void 0 : dbData.dbDetails) === null || _c === void 0 ? void 0 : _c.database) || 'database'] = {
            db_type: [],
            metadata: [],
        },
        _b)), metaData = _f[0], setMetaData = _f[1];
    var searchParams = useSearchParams()[0];
    var urlId = searchParams.get('id');
    var dbName = (_d = dbData === null || dbData === void 0 ? void 0 : dbData.dbDetails) === null || _d === void 0 ? void 0 : _d.database;
    var currentDbId = dbData === null || dbData === void 0 ? void 0 : dbData._id;
    // Use the update context
    var _g = useUpdateContext(), updateRowData = _g.updateRowData, isUpdateMode = _g.isUpdateMode, clearUpdateData = _g.clearUpdateData;
    var _h = useQuery("/metadatadbdetails?id=".concat(urlId || (dbData === null || dbData === void 0 ? void 0 : dbData._id)), expandedDBs.includes(dbName)), apiResponse = _h.data, loading = _h.loading, error = _h.error;
    // Check if this database matches the one in update context
    var isCurrentDbInUpdateContext = function () {
        if (!isUpdateMode || !updateRowData)
            return false;
        return updateRowData.databaseId === currentDbId;
    };
    // Auto-expand and pre-populate data in update mode
    useEffect(function () {
        if (isUpdateMode &&
            updateRowData &&
            dbName &&
            !expandedDBs.includes(dbName) &&
            isCurrentDbInUpdateContext()) {
            setExpandedDBs(function (prev) { return __spreadArray(__spreadArray([], prev, true), [dbName], false); });
            setDatabaseInfo({
                dbDetails: dbData,
                collection: '',
                dbName: dbName,
            });
            if (updateRowData.table) {
                var tableObj = updateRowData.table;
                if (tableObj.all === true) {
                    console.log('All tables were selected in the original configuration');
                }
                else {
                    var selectedTableNames_1 = Object.keys(tableObj).filter(function (key) { return key !== 'all'; });
                    setSelectedCollections(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[dbName] = selectedTableNames_1, _a)));
                    });
                }
            }
        }
    }, [isUpdateMode, updateRowData, dbName, expandedDBs, currentDbId]);
    useEffect(function () {
        var _a;
        var _b;
        if (apiResponse) {
            setAllMetaData(apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse[dbName]);
            setMetaData((_a = {},
                _a[dbName] = __assign({}, apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse[dbName]),
                _a));
            if (isUpdateMode && ((_b = updateRowData === null || updateRowData === void 0 ? void 0 : updateRowData.table) === null || _b === void 0 ? void 0 : _b.all) === true && isCurrentDbInUpdateContext()) {
                var allCollections_1 = Object.keys((apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse[dbName]) || {});
                setSelectedCollections(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[dbName] = allCollections_1, _a)));
                });
            }
        }
    }, [apiResponse, isUpdateMode, updateRowData, currentDbId]);
    useEffect(function () {
        if (isUpdateMode && updateRowData && apiResponse && isCurrentDbInUpdateContext()) {
            var tableObj_1 = updateRowData.table;
            if (tableObj_1 && typeof tableObj_1 === 'object') {
                Object.keys(tableObj_1).forEach(function (tableName) {
                    var _a;
                    if (tableName !== 'all') {
                        var tableConfig = tableObj_1[tableName];
                        var tableData = ((_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse[dbName]) === null || _a === void 0 ? void 0 : _a[tableName]) || [];
                        var processedTableData = tableData.map(function (fieldObj) { return ({
                            field: fieldObj.field,
                            type: fieldObj.type || 'string',
                            isEncrypted: false,
                            isDisable: fieldObj.isDisable,
                            tooltipMsg: fieldObj.tooltipMsg || '',
                        }); });
                        if (tableConfig.all === true) {
                            processedTableData.forEach(function (fieldObj) {
                                fieldObj.isEncrypted = true;
                            });
                        }
                        else if (tableConfig.fields && Array.isArray(tableConfig.fields)) {
                            var encryptedFieldsMap_1 = new Map(tableConfig.fields.map(function (item) { return [item.field, true]; }));
                            processedTableData.forEach(function (fieldObj) {
                                fieldObj.isEncrypted = encryptedFieldsMap_1.has(fieldObj.field);
                            });
                        }
                        onCollectionSelection(tableName, processedTableData);
                        handleCollectionClick(tableName);
                    }
                });
            }
        }
    }, [isUpdateMode, updateRowData, apiResponse, currentDbId, dbName]);
    function getCollection(name) {
        var _a;
        return (_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse[dbName]) === null || _a === void 0 ? void 0 : _a[name];
    }
    // FIXED: Helper function to check if a collection should be considered "selected"
    // based on whether it has any encrypted fields
    function isCollectionEffectivelySelected(collectionName) {
        var fieldsData = collectionFieldsData[collectionName];
        if (!fieldsData || fieldsData.length === 0)
            return false;
        // NEW LOGIC: Check if ANY field is encrypted (not ALL fields)
        return fieldsData.some(function (field) { return field.isEncrypted === true; });
    }
    // FIXED: Helper function to initialize collection fields data if not present
    function initializeCollectionFieldsIfNeeded(collectionName) {
        if (!collectionFieldsData[collectionName]) {
            var data = getCollection(collectionName);
            if (data) {
                var fieldsWithEncryption = data.map(function (field) { return ({
                    field: field.field,
                    type: field.type || 'string',
                    isEncrypted: false,
                    isDisable: field.isDisable,
                    tooltipMsg: field.tooltipMsg || '',
                }); });
                onCollectionSelection(collectionName, fieldsWithEncryption);
            }
        }
    }
    function handleSelectCollection(dbName, collection) {
        // FIXED: Initialize collection fields data if needed
        initializeCollectionFieldsIfNeeded(collection);
        var selected = selectedCollections[dbName] || [];
        var isSelected = selected.includes(collection);
        var newSelections = isSelected
            ? selected.filter(function (item) { return item !== collection; })
            : __spreadArray(__spreadArray([], selected, true), [collection], false);
        setSelectedCollections(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[dbName] = newSelections, _a)));
        });
        if (onCollectionCheckboxChange) {
            onCollectionCheckboxChange(dbName, collection, !isSelected);
        }
    }
    // function handleSelectAll(dbName: string, allCollections: string[]) {
    function handleSelectAll(dbName, allCollections) {
        // Initialize all collection fields data before selecting all
        allCollections.forEach(function (collection) {
            initializeCollectionFieldsIfNeeded(collection);
        });
        // Check if all collections have at least one encrypted field
        var effectivelySelectedCollections = allCollections.filter(function (collectionName) {
            return isCollectionEffectivelySelected(collectionName);
        });
        var allSelected = effectivelySelectedCollections.length === allCollections.length;
        // Update selected collections based on the current effective selection state
        setSelectedCollections(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[dbName] = allSelected ? [] : __spreadArray([], allCollections, true), _a)));
        });
        if (onCollectionCheckboxChange) {
            allCollections.forEach(function (collection) {
                onCollectionCheckboxChange(dbName, collection, !allSelected);
            });
        }
    }
    function handleCollectionClick(collection) {
        var _a;
        var data = getCollection(collection);
        var existingFieldData = collectionFieldsData[collection];
        var fieldsWithEncryption;
        if (existingFieldData && existingFieldData.length > 0) {
            fieldsWithEncryption = existingFieldData;
        }
        else if (isUpdateMode && ((_a = updateRowData === null || updateRowData === void 0 ? void 0 : updateRowData.table) === null || _a === void 0 ? void 0 : _a[collection]) && isCurrentDbInUpdateContext()) {
            var tableConfig = updateRowData.table[collection];
            if (tableConfig.all === true) {
                fieldsWithEncryption =
                    (data === null || data === void 0 ? void 0 : data.map(function (field) { return ({
                        field: field.field,
                        type: field.type || 'string',
                        isEncrypted: true,
                        isDisable: field.isDisable,
                        tooltipMsg: field.tooltipMsg || '',
                    }); })) || [];
            }
            else if (tableConfig.fields && Array.isArray(tableConfig.fields)) {
                var encryptedFieldsMap_2 = new Map(tableConfig.fields.map(function (item) { return [item.field, true]; }));
                fieldsWithEncryption =
                    (data === null || data === void 0 ? void 0 : data.map(function (field) { return ({
                        field: field.field,
                        type: field.type || 'string',
                        isEncrypted: encryptedFieldsMap_2.has(field.field),
                        isDisable: field.isDisable,
                        tooltipMsg: field.tooltipMsg || '',
                    }); })) || [];
            }
            else {
                fieldsWithEncryption =
                    (data === null || data === void 0 ? void 0 : data.map(function (field) { return ({
                        field: field.field,
                        type: field.type || 'string',
                        isEncrypted: false,
                        isDisable: field.isDisable,
                        tooltipMsg: field.tooltipMsg || '',
                    }); })) || [];
            }
        }
        else {
            fieldsWithEncryption =
                (data === null || data === void 0 ? void 0 : data.map(function (field) { return ({
                    field: field.field,
                    type: field.type || 'string',
                    isEncrypted: false,
                    isDisable: field.isDisable,
                    tooltipMsg: field.tooltipMsg || '',
                }); })) || [];
        }
        setCollection(fieldsWithEncryption);
        setDatabaseInfo({
            dbDetails: dbData,
            collection: collection,
        });
        onCollectionSelection(collection, fieldsWithEncryption);
    }
    var toggleExpand = function (dbName) {
        setDatabaseInfo({
            dbDetails: dbData,
            collection: '',
            dbName: dbName,
        });
        setExpandedDBs(function (prev) {
            var isCurrentlyExpanded = prev.includes(dbName);
            if (isCurrentlyExpanded) {
                // If clicking on an already expanded DB, just close it
                return prev.filter(function (name) { return name !== dbName; });
            }
            else {
                // If clicking on a collapsed DB, close all others and open only this one
                return [dbName]; // This ensures only one DB is expanded at a time
            }
        });
    };
    return (_jsx("div", { children: Object.entries(metaData).map(function (_a) {
            var dbName = _a[0], collections = _a[1];
            var collectionNames = Object.keys(collections);
            var isExpanded = expandedDBs.includes(dbName);
            // FIXED: Check if all collections are selected based on actual encrypted fields
            var effectivelySelectedCollections = collectionNames.filter(function (collectionName) {
                return isCollectionEffectivelySelected(collectionName);
            });
            var allSelected = effectivelySelectedCollections.length === collectionNames.length &&
                collectionNames.length > 0;
            return (_jsxs("div", { children: [_jsxs("button", { onClick: function () { return toggleExpand(dbName); }, className: 'flex items-center w-full text-left px-2 py-1 hover:bg-gray-100 rounded-md', children: [loading && isExpanded && _jsx(Loader2, { className: 'w-4 h-4 mr-2 animate-spin' }), collectionNames.length > 0 ? (isExpanded ? (_jsx(ChevronDown, { className: 'w-4 h-4 mr-2' })) : (_jsx(ChevronRight, { className: 'w-4 h-4 mr-2' }))) : (_jsx("div", { className: 'w-4 h-4 mr-2' })), _jsx(Database, { className: 'w-4 h-4 mr-2 text-blue-500 ' }), _jsx("span", { className: 'text-sm font-medium cursor-pointer', children: dbName })] }), !loading && isExpanded && collectionNames.length > 0 && (_jsxs("div", { className: 'ml-6 mt-1 space-y-1', children: [_jsxs("label", { className: 'flex items-center space-x-2', children: [_jsx("input", { type: 'checkbox', checked: allSelected, onChange: function () { return handleSelectAll(dbName, collectionNames); } }), _jsx("span", { className: 'text-sm font-medium text-gray-700', children: "Select All" })] }), collectionNames.map(function (collection) {
                                // FIXED: Use the new helper function to determine if collection is selected
                                var isSelected = isCollectionEffectivelySelected(collection);
                                var wasOriginallySelected = isUpdateMode &&
                                    (updateRowData === null || updateRowData === void 0 ? void 0 : updateRowData.table) &&
                                    isCurrentDbInUpdateContext() &&
                                    (updateRowData.table.all === true || updateRowData.table[collection]);
                                return (_jsxs("div", { className: "flex items-center px-2 py-0.5 hover:bg-gray-50 rounded-md ".concat(wasOriginallySelected ? 'bg-blue-50' : ''), children: [_jsx("input", { type: 'checkbox', checked: isSelected, onClick: function (e) { return e.stopPropagation(); }, onChange: function () { return handleSelectCollection(dbName, collection); }, className: 'mr-2' }), _jsxs("div", { className: 'flex items-center cursor-pointer flex-1', onClick: function () { return handleCollectionClick(collection); }, children: [_jsx(Folder, { className: 'w-4 h-4 mr-2 text-gray-500' }), _jsx("span", { className: 'text-sm w-32 truncate inline-block', children: collection })] })] }, collection));
                            })] }))] }, dbName));
        }) }));
};
export default React.memo(DataBaseFolder);
